export default class Person {
  type;

  process(cart, productBySku) { }
  toDto() { }
}
